<template>
  <div>
    <el-select
      v-close-on-zoom
      :value="state.selectedLeads"
      placeholder="any lead"
      :filterable="true"
      :multiple="true"
      :disabled="readonly"
      class="lead-select"
      @input="keys => selectLeads(keys)"
    >
      <el-option
        v-for="lead in availableLeads"
        :key="lead.key"
        :label="lead.label.en"
        :value="lead.key"
      />
    </el-select>
    <help-tooltip v-if="enabledWarning" type="warning">
      {{ enabledWarning.message }}
    </help-tooltip>
    <help-tooltip v-if="leadWarning" type="warning">
      {{ leadWarning.message }}
    </help-tooltip>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'monitor-leads-action',
  components: {
    HelpTooltip,
  },
  props: [
    'treatments',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'valueBool',
  ],
  data() {
    return {
      state: {
        selectedLeads: [],
      },
    };
  },
  computed: {
    componentOptions() {
      const leadTmt = this.emitter.caseConf._treatments.find(t => t.id === 'LEAD_SELECT');
      return leadTmt ? leadTmt.options.componentOptions : {};
    },
    availableLeads() {
      return this.leads.filter(lead =>
        this.componentOptions.LEAD && this.componentOptions.LEAD.availableValues.includes(lead.key),
      );
    },
    leads() {
      const leadSelectTreatment = this.treatments.find(t => t.id === 'LEAD_SELECT');
      if (!leadSelectTreatment) {
        return [];
      }
      const leadComponent = leadSelectTreatment.components.find(c => c.key === 'LEAD');
      if (!leadComponent) {
        return [];
      }
      return leadComponent.metadata.values;
    },
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      return uniqBy(
        get(
          this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
          `caseLogicDescription.${this.control.parent.id}`,
          [],
        ).filter(
          warning => warning.metadata && warning.metadata.scope === 'control',
        ),
        'message',
      );
    },
    enabledWarning() {
      return this.warnings.find(warning => warning.metadata.componentId === 'LEAD_SELECT');
    },
    leadWarning() {
      return this.warnings.find(warning => warning.metadata.componentId === 'LEAD');
    },
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.selectedLeads = get(data, 'leads') || [];
    this.update();
  },
  methods: {
    selectLeads(keys) {
      this.state.selectedLeads = keys;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'LEADS',
        id: 'LEADS',
        leads: this.state.selectedLeads,
        valueBool: this.valueBool,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
</style>
